<template>
  <AppSidebar
    :visible="showSidebar"
    dismiss-on-body-click
    @close="toggleSidebar"
  >
    <AppTabs compact>
      <AppTab label="Filters">
        <div class="row">
          <div class="col-sm-12 basic-filters">
            <label>Classification</label>
            <div class="form-group">
              <AppSelect
                :value="filter.productivity"
                :options="classificationOptions"
                :select2-options="select2Options.productivity"
                @input="handleFilterChange($event, 'productivity')"
              />
            </div>
            <label>Type of items</label>
            <div class="form-group">
              <AppSelect
                :value="filters.tool_type"
                :options="toolTypeOptions"
                :select2-options="select2Options.toolType"
                @input="handleFilterChange($event, 'tool_type')"
              />
            </div>
            <label>Category</label>
            <div class="form-group">
              <AppSelect
                :value="filter.category"
                :options="categoryOptions"
                :select2-options="select2Options.category"
                @input="handleFilterChange($event, 'category')"
              />
            </div>
          </div>
        </div>
        <div class="mt-auto">
          <AppButton
            block
            :disabled="disabledClearButton"
            @click="clearSidebarFilters"
          >
            Clear filters
          </AppButton>
        </div>
      </AppTab>
    </AppTabs>
  </AppSidebar>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { SETTINGS_INSIGHTS } from '~/app_constants';
import select2DropdownParentMixin from '~/mixins/Select2DropdownParent';

const select2OptionsDefault = {
  allowClear: true,
  width: '100%',
  placeholder: 'Select an option',
};

export default {
  name: 'SettingsInsightsSidebar',
  mixins: [select2DropdownParentMixin],
  computed: {
    ...mapState(['showSidebar', 'filters', 'categories']),
    select2Options() {
      return {
        productivity: Object.freeze({ ...select2OptionsDefault, multiple: false }),
        toolType: Object.freeze({ ...select2OptionsDefault, multiple: true }),
        category: Object.freeze({ ...select2OptionsDefault, multiple: false, placeholder: 'Select a category' }),
      };
    },
    classificationOptions() {
      return SETTINGS_INSIGHTS.productivityOptions.map(({ id, label: text }) => ({ id, text }));
    },
    toolTypeOptions() {
      return SETTINGS_INSIGHTS.toolTypeOptions.map(({ id, label: text }) => ({ id, text }));
    },
    categoryOptions() {
      return this.categories.map(({ id, name: text }) => ({ id, text }));
    },
    filter: {
      get() {
        return this.filters;
      },
      set({ value, filter }) {
        this.setSidebarFilter({ value, filter });
      },
    },
    disabledClearButton() {
      return !this.filter.productivity && this.filter.tool_type.length === 0 && !this.filter.category;
    },
  },
  methods: {
    handleFilterChange(value, filter) {
      this.setSidebarFilter({ value, filter });
    },
    ...mapActions(['toggleSidebar', 'setSidebarFilter', 'clearSidebarFilters']),
  },
};
</script>
